module.exports = __webpack_public_path__ + "img/Policy.0846dd8.svg";